(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collaboration-section"] && !Shopify.designMode) return;
  try {
    
  $(".tda-app-section-content").before(`
    <div class="review" style="text-align: center;">
      <span 
      class="stamped-product-reviews-badge" 
      data-id="7222009626710"
      data-product-sku="timberox" 
      data-product-type="{{product.type}}" 
      data-product-title="TimberOX Summit 30-Ton Log Splitter" 
      style="display:block;">
      </span>
    </div>
  `);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logox-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('logox-card-video')) {
    customElements.define('logox-card-video', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.near = false;
        this.motion.addEventListener('change', () => this.syncPlayback(), options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.addEventListener('playing', () => {
          if (this.shouldPlay()) this.classList.add('is-playing');
          else this.video?.pause();
        }, { ...options, capture: true });
        this.addEventListener('error', () => this.classList.remove('is-playing'), { ...options, capture: true });
        if ('IntersectionObserver' in window) {
          this.loadObserver = new IntersectionObserver(entries => {
            this.near = entries[0].isIntersecting;
            this.syncPlayback();
          }, { rootMargin: '300px 0px' });
          this.playObserver = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.syncPlayback();
          });
          this.loadObserver.observe(this);
          this.playObserver.observe(this);
        } else {
          this.near = this.visible = true;
          this.syncPlayback();
        }
      }
      shouldPlay() {
        return this.isConnected && this.visible && !document.hidden && !this.motion.matches;
      }
      syncPlayback() {
        if (this.near && !this.motion.matches && !document.hidden && !this.video) {
          const template = this.querySelector('template');
          if (!template) return;
          this.append(template.content.cloneNode(true));
          this.video = this.querySelector('video');
          if (!this.video) return;
          this.video.muted = this.video.defaultMuted = true;
          this.video.loop = this.video.playsInline = true;
          this.video.controls = false;
          this.video.preload = 'metadata';
          this.video.load();
        }
        if (this.motion.matches) this.classList.remove('is-playing');
        if (!this.video) return;
        if (this.shouldPlay()) {
          if (!this.video.paused || this.playPending) return;
          this.playPending = true;
          this.video.play().catch(() => {
            if (this.video?.paused) this.classList.remove('is-playing');
          }).finally(() => { this.playPending = false; });
        } else {
          this.video.pause();
        }
      }
      disconnectedCallback() {
        this.loadObserver?.disconnect();
        this.playObserver?.disconnect();
        this.abort?.abort();
        this.abort = null;
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logox-media"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('logox-review-text')) {
  class LogoxReviewText extends HTMLElement {
    static nextId = 0;
    static openDialogs = new Set();
    static previousOverflow = '';

    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }

    setup() {
      this.body = this.querySelector('[data-review-body]');
      this.template = this.querySelector('[data-full-review]');
      this.button = this.querySelector('[data-review-open]');
      if (!this.body || !this.template || !this.button) return;
      this.body.replaceChildren(this.template.content.cloneNode(true));
      this.button.hidden = true;
      if (this.dataset.enabled !== 'true' || typeof HTMLDialogElement === 'undefined' ||
          typeof HTMLDialogElement.prototype.showModal !== 'function') return;
      const plain = this.template.content.cloneNode(true);
      plain.querySelectorAll('p, li, br, div, h1, h2, h3, h4, h5, h6').forEach(node => {
        node.before(document.createTextNode(' '));
        node.after(document.createTextNode(' '));
      });
      const words = plain.textContent.trim().split(/\s+/).filter(Boolean);
      const limit = Math.max(10, Math.min(200, Number(this.dataset.words) || 40));
      if (words.length <= limit) return;
      const excerpt = document.createElement('p');
      excerpt.textContent = words.slice(0, limit).join(' ') + '…';
      this.body.replaceChildren(excerpt);
      this.button.hidden = false;
      this.button.setAttribute('aria-label', this.button.textContent.trim() + ': ' + this.dataset.title);
      this.events = new AbortController();
      this.button.addEventListener('click', () => this.open(), { signal: this.events.signal });
    }

    open() {
      if (!this.dialog) this.createDialog();
      if (!this.dialog || this.dialog.open) return;
      this.dialog.showModal();
      if (!LogoxReviewText.openDialogs.size) {
        LogoxReviewText.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }
      LogoxReviewText.openDialogs.add(this);
      this.dialog.querySelector('h2').focus({ preventScroll: true });
    }

    createDialog() {
      const section = this.closest('.lxp-media');
      if (!section) return;
      const id = 'Logox-review-popup-' + (++LogoxReviewText.nextId);
      const dialog = document.createElement('dialog');
      dialog.id = id;
      dialog.className = 'lxp-review-dialog';
      dialog.style.cssText = this.style.cssText;
      dialog.style.fontFamily = getComputedStyle(this).fontFamily;
      dialog.setAttribute('aria-labelledby', id + '-title');
      const header = document.createElement('div');
      header.className = 'lxp-review-dialog__header';
      const title = document.createElement('h2');
      title.id = id + '-title';
      title.className = 'lxp-review-dialog__title';
      title.textContent = this.dataset.title;
      title.tabIndex = -1;
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'lxp-review-dialog__close';
      close.textContent = this.dataset.closeLabel;
      header.append(title, close);
      const content = document.createElement('div');
      content.className = 'lxp-review-dialog__body';
      content.append(this.template.content.cloneNode(true));
      dialog.append(header, content);
      if (this.dataset.author) {
        const author = document.createElement('p');
        author.className = 'lxp-review-dialog__author';
        author.textContent = this.dataset.author;
        dialog.append(author);
      }
      const options = { signal: this.events.signal };
      close.addEventListener('click', () => dialog.close(), options);
      const outside = event => {
        const rect = dialog.getBoundingClientRect();
        return event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom);
      };
      let startedOutside = false;
      dialog.addEventListener('pointerdown', event => { startedOutside = outside(event); }, options);
      dialog.addEventListener('click', event => {
        if (startedOutside && outside(event)) dialog.close();
        startedOutside = false;
      }, options);
      dialog.addEventListener('close', () => {
        this.unlockScroll();
        if (this.button.isConnected) this.button.focus({ preventScroll: true });
      }, options);
      section.append(dialog);
      this.dialog = dialog;
      this.button.setAttribute('aria-controls', id);
    }

    unlockScroll() {
      if (LogoxReviewText.openDialogs.delete(this) && !LogoxReviewText.openDialogs.size) {
        document.documentElement.style.overflow = LogoxReviewText.previousOverflow;
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
      this.unlockScroll();
      this.dialog?.remove();
      this.dialog = null;
      if (this.body && this.template) this.body.replaceChildren(this.template.content.cloneNode(true));
      if (this.button) {
        this.button.hidden = true;
        this.button.removeAttribute('aria-controls');
      }
    }
  }
  customElements.define('logox-review-text', LogoxReviewText);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logox-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('logox-story-video')) {
    customElements.define('logox-story-video', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.near = false;
        this.motion.addEventListener('change', () => this.syncPlayback(), options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.addEventListener('playing', () => {
          if (this.shouldPlay()) this.classList.add('is-playing');
          else this.video?.pause();
        }, { ...options, capture: true });
        this.addEventListener('error', () => this.classList.remove('is-playing'), { ...options, capture: true });
        if ('IntersectionObserver' in window) {
          this.loadObserver = new IntersectionObserver(entries => {
            this.near = entries[0].isIntersecting;
            this.syncPlayback();
          }, { rootMargin: '300px 0px' });
          this.playObserver = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.syncPlayback();
          });
          this.loadObserver.observe(this);
          this.playObserver.observe(this);
        } else {
          this.near = this.visible = true;
          this.syncPlayback();
        }
      }
      shouldPlay() {
        return this.isConnected && this.visible && !document.hidden && !this.motion.matches;
      }
      syncPlayback() {
        if (this.near && !this.motion.matches && !document.hidden && !this.video) {
          const template = this.querySelector('template');
          if (!template) return;
          this.append(template.content.cloneNode(true));
          this.video = this.querySelector('video');
          if (!this.video) return;
          this.video.muted = this.video.defaultMuted = true;
          this.video.loop = this.video.playsInline = true;
          this.video.controls = false;
          this.video.preload = 'metadata';
          this.video.load();
        }
        if (this.motion.matches) this.classList.remove('is-playing');
        if (!this.video) return;
        if (this.shouldPlay()) {
          if (!this.video.paused || this.playPending) return;
          this.playPending = true;
          this.video.play().catch(() => {
            if (this.video?.paused) this.classList.remove('is-playing');
          }).finally(() => { this.playPending = false; });
        } else {
          this.video.pause();
        }
      }
      disconnectedCallback() {
        this.loadObserver?.disconnect();
        this.playObserver?.disconnect();
        this.abort?.abort();
        this.abort = null;
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
